module.exports = __webpack_public_path__ + "1791188489487/fonts/fa-brands-400.fdf44bc.ttf";